











































import { TicketParams } from '@/store/interfaces/tickets';
import { ticketableType } from '@/util/transformString/translationsDecorator';
import Vue, { PropType } from 'vue';

type typeOfTicketable = { name: string, value: string, }

type data = {
  ticketableType: (value: string) => string,
  typeOfTicketablePosition: number,
  status: string,
  typeOfTicketable: typeOfTicketable[],
}

export default Vue.extend({
  name: 'UpdateTicketModal',
  props: {
    ticket: {
      type: Object as PropType<TicketParams>,
      required: true,
    },
    viewModal: {
      type: Boolean,
      required: true,
    },
    processing: {
      type: Boolean,
      required: true,
    },
    success: {
      type: Boolean,
      required: true,
    },
  },
  data(): data {
    return {
      ticketableType,
      typeOfTicketablePosition: 1,
      status: '',
      typeOfTicketable: [
        {
          name: 'Completada',
          value: 'completed',
        },
        {
          name: 'Pendiente',
          value: 'pending',
        },
        {
          name: 'Cancelada',
          value: 'cancelled',
        }
      ],
    };
  },
  watch: {
    ticket: {
      immediate: true,
      deep: true,
      handler(tick: TicketParams): void {
        if (Object.keys(tick).length > 0) {
          const typeOfTicketablePosition = this.$data.typeOfTicketable.findIndex(
            (pos: typeOfTicketable) => pos.value === tick.status
          );
          this.$data.typeOfTicketablePosition = typeOfTicketablePosition + 1;
          this.$data.status = tick.status;
        }
      },
    },
    success: {
      immediate: true,
      deep: true,
      handler(suc: boolean): void {
        if (suc) this.syncedViewModal = false;
      },
    },
  },
  computed: {
    syncedViewModal: {
      get(): boolean {
        return this.viewModal;
      },
      set(value: boolean): void {
        this.$emit('update:viewModal', value);
      },
    },
  },
  methods: {
    close(): void {
      this.syncedViewModal = false;
    },
    updateTicket(): void {
      this.$emit('update', this.$data.status);
    },
  },
});
